import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import useWindowsDimension from 'functions/useWindowsDimension';
import React, { useState } from 'react';

interface DrawerProps {
  buttonIcon: React.ReactNode;
  buttonContext: string;
  handleChange: (event: React.MouseEvent<HTMLElement>) => void;
  onLetterChange: (letter: string) => void;
  fullHeight?: boolean;
}

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ'.split('');

export const AlphabetSortDrawer: React.FC<DrawerProps> = ({
  buttonIcon,
  buttonContext,
  handleChange,
  onLetterChange,
  fullHeight,
}) => {
  const [page, setPage] = useState(1);
  const [letterFilter, setLetterFilter] = useState('');
  const { height } = useWindowsDimension();

  // Filters

  return (
    <>
      <Box
        sx={{
          height: fullHeight ? height - 100 : height - 244,
          width: 50,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'primary.darkest',
        }}
      >
        {/* Middle: alphabet + list */}
        <Box sx={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
          {/* Alphabet - left */}
          <Box
            sx={{
              width: 50,
              overflowY: 'auto',
              bgcolor: 'primary.dark',
              '&::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
            }}
          >
            <ToggleButtonGroup
              orientation='vertical'
              size='small'
              value={letterFilter}
              exclusive
              onChange={(_, v: string) => {
                setLetterFilter(v);
                setPage(1);
                onLetterChange(v);
              }}
              sx={{
                '& .MuiToggleButton-root': {
                  width: '100%',
                },
              }}
            >
              <ToggleButton value=''>Alle</ToggleButton>
              {ALPHABET.map((letter) => (
                <ToggleButton key={letter} value={letter}>
                  {letter}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AlphabetSortDrawer;
